
import TableList from "@components/templates/tablelist";
import { HttpLineMaintainList, HttpDeleteLineMaintain, HttpbatchCreateProduct } from "@/service/setting";
import { HttpGetCategories } from '@/service/products/allproducts'
import { mapGetters } from "vuex";
import comIndex from './update'
import compInventory from '../../products/allproducts/inventory'
import mixin from './mixin'
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex,
        compInventory
    },
    data () {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: { show: true },
            TreeSearchs: {
                show: true,
                data: [
                    {
                        label: "所有",
                        key: "EQ_targetType",
                        value: 3,
                    },
                    {
                        label: "销售目标",
                        key: "EQ_targetType",
                        value: 0,
                    },
                    {
                        label: "利润目标",
                        key: "EQ_targetType",
                        value: 1,
                    }
                ]
            },
            categoryList: []
        };
    },
    created() {
        this.getCategory();
    },
    methods: {
        ajaxRequest: HttpLineMaintainList,
        interceptRequest (params) {
            console.log("interceptRequest", params);
            return this.handleParams(params);
        },
        handleParams (params) {
            let { search, ...result } = { ...params };
            let { EQ_targetType, BT_targetMonth, ...otherSearch} = search;
            // 不为所有
            if (EQ_targetType != 3) {
                otherSearch = {
                    ...otherSearch,
                    EQ_targetType
                };
            }
            // 月度改为范围搜索
            if (BT_targetMonth) {
                let dateArr = BT_targetMonth.split(" ~ ");
                otherSearch = {
                    ...otherSearch,
                    GE_targetMonth: dateArr[0],
                    LE_targetMonth: dateArr[1]
                };
            }
            return {
                ...result,
                search: {
                    ...otherSearch
                }
            };
        },
        handleOperates (params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.operate = {
                        title: '添加',
                        show: true,
                        width: 800,
                        component: "comIndex",
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case "edit":
                    this.operate = {
                        title: '编辑',
                        show: true,
                        width: 800,
                        activeid: params,
                        component: "comIndex",
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 800,
                        component: "comIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "删除",
                        width: 460,
                        showDesc: true,
                        params: { id: params },
                        // formdata: [
                        //     {
                        //         tag: "vTextarea",
                        //         key: "remark",
                        //         span: 24,
                        //         label: "备注",
                        //         required: false,
                        //     }
                        // ],
                        ajaxRequest: HttpDeleteLineMaintain
                    };
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.muti_import', { defaultValue: "批量导入" }),
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/ProductLineTarget/import",
                        name: "excelFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/ProductLineTarget/excel', {}, 'download')
                        },

                    };
                    break
                case "exportQuery":
                    {
                        let result = this.handleParams(this.formData);
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v1/ProductLineTarget/exportByFilter",
                            {
                                ...result,
                            },
                            "download"
                        );
                    }
                    break;
            }
        },
        getOperateNodeMap (row) {
            const { id, isChannelRelate } = row
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            }, {
                label: '删除',
                show: true,
                params: id,
                operate: 'delete'
            },]
        },
        getCategory () {
            HttpGetCategories().then(res=>{
                res.data.map(item=>{
                    if(item.level == 3){
                        let data = {
                            label:item.name+' '+item.code,
                            value:item.code
                        }
                        this.categoryList.push(data)
                    }
                })
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getNewDifferentAllProductList', 'getNewAllProductWithoutOrgList','getAccountList']),
        ...mapGetters('diction', ['getNewProductList', 'getNewAccountList']),
        
        // accountsTarget () {
        //     return this.getNewAccountList.map((item) => {
        //         // console.log(item)
        //         const bool = item.attach.status === 'inactive' && item.attach.type == "amazon";
        //         return {
        //             label: bool ? `<span style='text-decoration:line-through'>${item.label}</span>` : `${item.label}`,
        //             value: item.value,
        //             // disabled:bool

        //         }
        //     })
        // },
        ToolsData () {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: 'primary'
                },
                {
                    name: "批量导入",
                    operate: "import",
                    more: true,
                    batch: false
                },
                {
                    name: "批量删除",
                    operate: "delete",
                    more: true,
                    batch: true
                },
                {
                    name: "查询条件导出",
                    operate: "exportQuery",
                    more: true,
                    batch: false
                },
            ]
        },
        SearchsData () {
            return [
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'IN_lineId',
                    show: true,
                    options: this.getNewProductList,
                    props: {
                        multiple: true,
                        filterable: true,
                    }
                },

                {
                    label: "业务类型",
                    tag: "vSelect",
                    key: "IN_bussinessType",
                    options: this.getBussinessType,
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    show: true
                },
                {
                    label: "品类",
                    tag: "vSelect",
                    key: "CN_category",
                    props: {
                        filterable: true
                    },
                    options: this.categoryList,
                    show: true
                },
                {
                    label: "月度",
                    tag: "vDatepicker",
                    key: "BT_targetMonth",
                    props: {
                        format: "yyyy-mm ~ yyyy-mm",
                        confirm: false
                    },
                    show: true
                },
            ]
        },
        columns() {
            return  [
            {
                type: "selection",
                width: 30,
                formName: "id"
            },
            {
                title: '操作',
                width: 90,
                render:this.getOperateNodes,
            },
            {
                title: '项目',
                sortable: true,
                render: (h, { row }) => this.findRenderLabel(this.getNewAllProductWithoutOrgList, row.lineId),
            },
            {
                title: '目标类型',
                render:(h,{row})=>{
                    return <div>{this.findRenderLabel(this.getTargetType, row.targetType)}</div>
                }
            },
            {
                title: '业务类型',
                render:(h,{row})=>{
                    return <div>{this.findRenderLabel(this.getBussinessType, row.bussinessType)}</div>
                }
            },
            
            {
                title: '品类',
                key: 'categoryName'
            },
            {
                title: "月度",
                key: "targetMonth"
            },
            {
                title: "目标（USD）",
                key: "targetValue"
            },
            {
                title: "创建时间",
                key: "createdAt"
            },
            {
                title: '更新时间',
                key:'updatedAt'
            },
        ];
        },

    },

};
